export const countryOptionsPayoneer = [
  { key: "af", value: "af", flag: "af", text: "Afghanistan", postalCode: "1001" },
  { key: "ax", value: "ax", flag: "ax", text: "Aland Islands", postalCode: "22150" },
  { key: "al", value: "al", flag: "al", text: "Albania", postalCode: "1001" },
  { key: "dz", value: "dz", flag: "dz", text: "Algeria", postalCode: "40304" },
  { key: "as", value: "as", flag: "as", text: "American Samoa", postalCode: "96799" },
  { key: "ad", value: "ad", flag: "ad", text: "Andorra", postalCode: "AD100" },
  { key: "ao", value: "ao", flag: "ao", text: "Angola", postalCode: "00000" },
  { key: "ai", value: "ai", flag: "ai", text: "Anguilla", postalCode: "2640" },
  { key: "ag", value: "ag", flag: "ag", text: "Antigua", postalCode: "00000" },
  { key: "ar", value: "ar", flag: "ar", text: "Argentina", postalCode: "C1070AAM" },
  { key: "am", value: "am", flag: "am", text: "Armenia", postalCode: "375010" },
  { key: "aw", value: "aw", flag: "aw", text: "Aruba", postalCode: "00000" },
  { key: "au", value: "au", flag: "au", text: "Australia", postalCode: "2060" },
  { key: "at", value: "at", flag: "at", text: "Austria", postalCode: "1010" },
  { key: "az", value: "az", flag: "az", text: "Azerbaijan", postalCode: "1000" },
  { key: "bs", value: "bs", flag: "bs", text: "Bahamas", postalCode: "00000" },
  { key: "bh", value: "bh", flag: "bh", text: "Bahrain", postalCode: "317" },
  { key: "bd", value: "bd", flag: "bd", text: "Bangladesh", postalCode: "1340" },
  { key: "bb", value: "bb", flag: "bb", text: "Barbados", postalCode: "BB23026" },
  { key: "by", value: "by", flag: "by", text: "Belarus", postalCode: "223016" },
  { key: "be", value: "be", flag: "be", text: "Belgium", postalCode: "4000" },
  { key: "bz", value: "bz", flag: "bz", text: "Belize", postalCode: "00000" },
  { key: "bj", value: "bj", flag: "bj", text: "Benin", postalCode: "00000" },
  { key: "bm", flag: "bm", text: "Bermuda", value: "bm", postalCode: "FL 07" },
  { key: "bt", flag: "bt", text: "Bhutan", value: "bt", postalCode: "11001" },
  { key: "bo", flag: "bo", text: "Bolivia", value: "bo", postalCode: "00000" },
  { key: "ba", flag: "ba", text: "Bosnia", value: "ba", postalCode: "71000" },
  { key: "bw", flag: "bw", text: "Botswana", value: "bw", postalCode: "00000" },
  { key: "bv", flag: "bv", text: "Bouvet Island", value: "bv", postalCode: "00000" },
  { key: "br", flag: "br", text: "Brazil", value: "br", postalCode: "40301-110" },
  { key: "vg", flag: "vg", text: "British Virgin Islands", value: "vg", postalCode: "VG1110" },
  { key: "bn", flag: "bn", text: "Brunei", value: "bn", postalCode: "BT2328" },
  { key: "bg", flag: "bg", text: "Bulgaria", value: "bg", postalCode: "1000" },
  { key: "bf", flag: "bf", text: "Burkina Faso", value: "bf", postalCode: "00000" },
  { key: "mm", flag: "mm", text: "Burma", value: "mm", alias: "Myanmar", postalCode: "11181" },
  { key: "bi", flag: "bi", text: "Burundi", value: "bi", postalCode: "00000" },
  { key: "tc", flag: "tc", text: "Caicos Islands", value: "tc", postalCode: "TKCA 1ZZ" },
  { key: "kh", flag: "kh", text: "Cambodia", value: "kh", postalCode: "120101" },
  { key: "cm", flag: "cm", text: "Cameroon", value: "cm", postalCode: "00000" },
  { key: "ca", flag: "ca", text: "Canada", value: "ca", postalCode: "H3Z 2Y7" },
  { key: "cv", flag: "cv", text: "Cape Verde", value: "cv", postalCode: "7600" },
  { key: "ky", flag: "ky", text: "Cayman Islands", value: "ky", postalCode: "KY1-1100" },
  { key: "cf", flag: "cf", text: "Central African Republic", value: "cf", postalCode: "00000" },
  { key: "td", flag: "td", text: "Chad", value: "td", postalCode: "00000" },
  { key: "cl", flag: "cl", text: "Chile", value: "cl", postalCode: "8340457" },
  { key: "cn", flag: "cn", text: "China", value: "cn", postalCode: "266033" },
  { key: "cx", flag: "cx", text: "Christmas Island", value: "cx", postalCode: "6798" },
  { key: "cc", flag: "cc", text: "Cocos Islands", value: "cc", postalCode: "6799" },
  { key: "co", flag: "co", text: "Colombia", value: "co", postalCode: "111221" },
  { key: "km", flag: "km", text: "Comoros", value: "km", postalCode: "00000" },
  { key: "cd", flag: "cd", text: "Congo", value: "cd", postalCode: "00000" },
  { key: "cg", flag: "cg", text: "Congo Brazzaville", value: "cg", postalCode: "00000" },
  { key: "ck", flag: "ck", text: "Cook Islands", value: "ck", postalCode: "00000" },
  { key: "cr", flag: "cr", text: "Costa Rica", value: "cr", postalCode: "1000" },
  { key: "ci", flag: "ci", text: "Cote Divoire", value: "ci", postalCode: "00000" },
  { key: "hr", flag: "hr", text: "Croatia", value: "hr", postalCode: "10000" },
  { key: "cu", flag: "cu", text: "Cuba", value: "cu", postalCode: "10700" },
  { key: "cy", flag: "cy", text: "Cyprus", value: "cy", postalCode: "2008" },
  { key: "cz", flag: "cz", text: "Czech Republic", value: "cz", postalCode: "100 00" },
  { key: "dk", flag: "dk", text: "Denmark", value: "dk", postalCode: "8660" },
  { key: "dj", flag: "dj", text: "Djibouti", value: "dj", postalCode: "00000" },
  { key: "dm", flag: "dm", text: "Dominica", value: "dm", postalCode: "00000" },
  { key: "do", flag: "do", text: "Dominican Republic", value: "do", postalCode: "11903" },
  { key: "ec", flag: "ec", text: "Ecuador", value: "ec", postalCode: "090105" },
  { key: "eg", flag: "eg", text: "Egypt", value: "eg", postalCode: "12411" },
  { key: "sv", flag: "sv", text: "El Salvador", value: "sv", postalCode: "CP 1101" },
  { key: "gb", flag: "gb", text: "England", value: "gb eng", postalCode: "EC1Y 8SY" },
  { key: "gq", flag: "gq", text: "Equatorial Guinea", value: "gq", postalCode: "00000" },
  { key: "er", flag: "er", text: "Eritrea", value: "er", postalCode: "00000" },
  { key: "ee", flag: "ee", text: "Estonia", value: "ee", postalCode: "69501" },
  { key: "et", flag: "et", text: "Ethiopia", value: "et", postalCode: "1000" },
  { key: "eu", flag: "eu", text: "Europeanunion", value: "eu", postalCode: "00000" },
  { key: "fk", flag: "fk", text: "Falkland Islands", value: "fk", postalCode: "FIQQ 1ZZ" },
  { key: "fo", flag: "fo", text: "Faroe Islands", value: "fo", postalCode: "100" },
  { key: "fj", flag: "fj", text: "Fiji", value: "fj", postalCode: "00000" },
  { key: "fi", flag: "fi", text: "Finland", value: "fi", postalCode: "00550" },
  { key: "fr", flag: "fr", text: "France", value: "fr", postalCode: "33380" },
  { key: "gf", flag: "gf", text: "French Guiana", value: "gf", postalCode: "97300" },
  { key: "pf", flag: "pf", text: "French Polynesia", value: "pf", postalCode: "98709" },
  { key: "tf", flag: "tf", text: "French Territories", value: "tf", postalCode: "00000" },
  { key: "ga", flag: "ga", text: "Gabon", value: "ga", postalCode: "00000" },
  { key: "gm", flag: "gm", text: "Gambia", value: "gm", postalCode: "00000" },
  { key: "ge", flag: "ge", text: "Georgia", value: "ge", postalCode: "0101" },
  { key: "de", flag: "de", text: "Germany", value: "de", postalCode: "26133" },
  { key: "gh", flag: "gh", text: "Ghana", value: "gh", postalCode: "00000" },
  { key: "gi", flag: "gi", text: "Gibraltar", value: "gi", postalCode: "GX11 1AA" },
  { key: "gr", flag: "gr", text: "Greece", value: "gr", postalCode: "151 24" },
  { key: "gl", flag: "gl", text: "Greenland", value: "gl", postalCode: "3900" },
  { key: "gd", flag: "gd", text: "Grenada", value: "gd", postalCode: "00000" },
  { key: "gp", flag: "gp", text: "Guadeloupe", value: "gp", postalCode: "97100" },
  { key: "gu", flag: "gu", text: "Guam", value: "gu", postalCode: "96910" },
  { key: "gt", flag: "gt", text: "Guatemala", value: "gt", postalCode: "09001" },
  { key: "gn", flag: "gn", text: "Guinea", value: "gn", postalCode: "001" },
  { key: "gw", flag: "gw", text: "Guinea-Bissau", value: "gw", postalCode: "1000" },
  { key: "gy", flag: "gy", text: "Guyana", value: "gy", postalCode: "00000" },
  { key: "ht", flag: "ht", text: "Haiti", value: "ht", postalCode: "6120" },
  { key: "hm", flag: "hm", text: "Heard Island", value: "hm", postalCode: "7050" },
  { key: "hn", flag: "hn", text: "Honduras", value: "hn", postalCode: "31301" },
  { key: "hk", flag: "hk", text: "Hong Kong", value: "hk", postalCode: "00000" },
  { key: "hu", flag: "hu", text: "Hungary", value: "hu", postalCode: "1037" },
  { key: "is", flag: "is", text: "Iceland", value: "is", postalCode: "320" },
  { key: "in", flag: "in", text: "India", value: "in", postalCode: "110034" },
  { key: "io", flag: "io", text: "Indian Ocean Territory", value: "io", postalCode: "BBND 1ZZ" },
  { key: "id", flag: "id", text: "Indonesia", value: "id", postalCode: "40115" },
  { key: "ir", flag: "ir", text: "Iran", value: "ir", postalCode: "11936-12345" },
  { key: "iq", flag: "iq", text: "Iraq", value: "iq", postalCode: "31001" },
  { key: "ie", flag: "ie", text: "Ireland", value: "ie", postalCode: "A65 F4E2" },
  { key: "il", flag: "il", text: "Israel", value: "il", postalCode: "9614303" },
  { key: "it", flag: "it", text: "Italy", value: "it", postalCode: "00144" },
  { key: "jm", flag: "jm", text: "Jamaica", value: "jm", postalCode: "00000" },
  { key: "sj", flag: "sj", text: "Jan Mayen", value: "sj", alias: "Svalbard", postalCode: "9170" },
  { key: "jp", flag: "jp", text: "Japan", value: "jp", postalCode: "154-0023" },
  { key: "jo", flag: "jo", text: "Jordan", value: "jo", postalCode: "11937" },
  { key: "kz", flag: "kz", text: "Kazakhstan", value: "kz", postalCode: "040900" },
  { key: "ke", flag: "ke", text: "Kenya", value: "ke", postalCode: "20100" },
  { key: "ki", flag: "ki", text: "Kiribati", value: "ki", postalCode: "00000" },
  { key: "xk", flag: "xk", text: "Kosovo ", value: "xk", postalCode: "10000" },
  { key: "kw", flag: "kw", text: "Kuwait", value: "kw", postalCode: "54541" },
  { key: "kg", flag: "kg", text: "Kyrgyzstan", value: "kg", postalCode: "720001" },
  { key: "la", flag: "la", text: "Laos", value: "la", postalCode: "01160" },
  { key: "lv", flag: "lv", text: "Latvia", value: "lv", postalCode: "LV-1073" },
  { key: "lb", flag: "lb", text: "Lebanon", value: "lb", postalCode: "2038 3054" },
  { key: "ls", flag: "ls", text: "Lesotho", value: "ls", postalCode: "100" },
  { key: "lr", flag: "lr", text: "Liberia", value: "lr", postalCode: "1000" },
  { key: "ly", flag: "ly", text: "Libya", value: "ly", postalCode: "00000" },
  { key: "li", flag: "li", text: "Liechtenstein", value: "li", postalCode: "9496" },
  { key: "lt", flag: "lt", text: "Lithuania", value: "lt", postalCode: "04340" },
  { key: "lu", flag: "lu", text: "Luxembourg", value: "lu", postalCode: "4750" },
  { key: "mo", flag: "mo", text: "Macau", value: "mo", postalCode: "00000" },
  { key: "mk", flag: "mk", text: "Macedonia", value: "mk", postalCode: "1314" },
  { key: "mg", flag: "mg", text: "Madagascar", value: "mg", postalCode: "501" },
  { key: "mw", flag: "mw", text: "Malawi", value: "mw", postalCode: "00000" },
  { key: "my", flag: "my", text: "Malaysia", value: "my", postalCode: "43000" },
  { key: "mv", flag: "mv", text: "Maldives", value: "mv", postalCode: "20026" },
  { key: "ml", flag: "ml", text: "Mali", value: "ml", postalCode: "00000" },
  { key: "mt", flag: "mt", text: "Malta", value: "mt", postalCode: "NXR 01" },
  { key: "mh", flag: "mh", text: "Marshall Islands", value: "mh", postalCode: "96960" },
  { key: "mq", flag: "mq", text: "Martinique", value: "mq", postalCode: "97220" },
  { key: "mr", flag: "mr", text: "Mauritania", value: "mr", postalCode: "00000" },
  { key: "mu", flag: "mu", text: "Mauritius", value: "mu", postalCode: "42602" },
  { key: "yt", flag: "yt", text: "Mayotte", value: "yt", postalCode: "97600" },
  { key: "mx", flag: "mx", text: "Mexico", value: "mx", postalCode: "02860" },
  { key: "fm", flag: "fm", text: "Micronesia", value: "fm", postalCode: "96941" },
  { key: "md", flag: "md", text: "Moldova", value: "md", postalCode: "2012" },
  { key: "mc", flag: "mc", text: "Monaco", value: "mc", postalCode: "98000" },
  { key: "mn", flag: "mn", text: "Mongolia", value: "mn", postalCode: "65030" },
  { key: "me", flag: "me", text: "Montenegro", value: "me", postalCode: "81257" },
  { key: "ms", flag: "ms", text: "Montserrat", value: "ms", postalCode: "00000" },
  { key: "ma", flag: "ma", text: "Morocco", value: "ma", postalCode: "53000" },
  { key: "mz", flag: "mz", text: "Mozambique", value: "mz", postalCode: "1102" },
  { key: "na", flag: "na", text: "Namibia", value: "na", postalCode: "10001" },
  { key: "nr", flag: "nr", text: "Nauru", value: "nr", postalCode: "00000" },
  { key: "np", flag: "np", text: "Nepal", value: "np", postalCode: "44601" },
  { key: "nl", flag: "nl", text: "Netherlands", value: "nl", postalCode: "1234 AB" },
  { key: "an", flag: "an", text: "Netherlandsantilles", value: "an", postalCode: "00000" },
  { key: "nc", flag: "nc", text: "New Caledonia", value: "nc", postalCode: "98814" },
  { key: "pg", flag: "pg", text: "New Guinea", value: "pg", postalCode: "111" },
  { key: "nz", flag: "nz", text: "New Zealand", value: "nz", postalCode: "6001" },
  { key: "ni", flag: "ni", text: "Nicaragua", value: "ni", postalCode: "52000" },
  { key: "ne", flag: "ne", text: "Niger", value: "ne", postalCode: "8001" },
  { key: "ng", flag: "ng", text: "Nigeria", value: "ng", postalCode: "930283" },
  { key: "nu", flag: "nu", text: "Niue", value: "nu", postalCode: "00000" },
  { key: "nf", flag: "nf", text: "Norfolk Island", value: "nf", postalCode: "2899" },
  { key: "kp", flag: "kp", text: "North Korea", value: "kp", postalCode: "00000" },
  { key: "mp", flag: "mp", text: "Northern Mariana Islands", value: "mp", postalCode: "96950" },
  { key: "no", flag: "no", text: "Norway", value: "no", postalCode: "0025" },
  { key: "om", flag: "om", text: "Oman", value: "om", postalCode: "133" },
  { key: "pk", flag: "pk", text: "Pakistan", value: "pk", postalCode: "44000" },
  { key: "pw", flag: "pw", text: "Palau", value: "pw", postalCode: "96940" },
  { key: "ps", flag: "ps", text: "Palestine", value: "ps", postalCode: "00000" },
  { key: "pa", flag: "pa", text: "Panama", value: "pa", postalCode: "00000" },
  { key: "py", flag: "py", text: "Paraguay", value: "py", postalCode: "1536" },
  { key: "pe", flag: "pe", text: "Peru", value: "pe", postalCode: "LIMA 23" },
  { key: "ph", flag: "ph", text: "Philippines", value: "ph", postalCode: "1008" },
  { key: "pn", flag: "pn", text: "Pitcairn Islands", value: "pn", postalCode: "PCRN 1ZZ" },
  { key: "pl", flag: "pl", text: "Poland", value: "pl", postalCode: "00-950" },
  { key: "pt", flag: "pt", text: "Portugal", value: "pt", postalCode: "2725-079" },
  { key: "pr", flag: "pr", text: "Puerto Rico", value: "pr", postalCode: "00930" },
  { key: "qa", flag: "qa", text: "Qatar", value: "qa", postalCode: "00000" },
  { key: "re", flag: "re", text: "Reunion", value: "re", postalCode: "97400" },
  { key: "ro", flag: "ro", text: "Romania", value: "ro", postalCode: "060274" },
  { key: "ru", flag: "ru", text: "Russia", value: "ru", postalCode: "247112" },
  { key: "rw", flag: "rw", text: "Rwanda", value: "rw", postalCode: "00000" },
  { key: "sh", flag: "sh", text: "Saint Helena", value: "sh", postalCode: "STHL 1ZZ" },
  { key: "kn", flag: "kn", text: "Saint Kitts and Nevis", value: "kn", postalCode: "00000" },
  { key: "lc", flag: "lc", text: "Saint Lucia", value: "lc", postalCode: "00000" },
  { key: "pm", flag: "pm", text: "Saint Pierre", value: "pm", postalCode: "97500" },
  { key: "vc", flag: "vc", text: "Saint Vincent", value: "vc", postalCode: "VC0100" },
  { key: "ws", flag: "ws", text: "Samoa", value: "ws", postalCode: "00000" },
  { key: "sm", flag: "sm", text: "San Marino", value: "sm", postalCode: "47890" },
  { key: "gs", flag: "gs", text: "Sandwich Islands", value: "gs", postalCode: "SIQQ 1ZZ" },
  { key: "st", flag: "st", text: "Sao Tome", value: "st", postalCode: "00000" },
  { key: "sa", flag: "sa", text: "Saudi Arabia", value: "sa", postalCode: "11564" },
  { key: "gb sct", flag: "gb sct", text: "Scotland", value: "gb sct", postalCode: "EH1 1YZ" },
  { key: "sn", flag: "sn", text: "Senegal", value: "sn", postalCode: "12500" },
  { key: "cs", flag: "cs", text: "Serbia and Montenegro", value: "cs", postalCode: "11000" },
  { key: "rs", flag: "rs", text: "Serbia", value: "rs", postalCode: "106314" },
  { key: "sc", flag: "sc", text: "Seychelles", value: "sc", postalCode: "00000" },
  { key: "sl", flag: "sl", text: "Sierra Leone", value: "sl", postalCode: "00000" },
  { key: "sg", flag: "sg", text: "Singapore", value: "sg", postalCode: "546080" },
  { key: "sk", flag: "sk", text: "Slovakia", value: "sk", postalCode: "010 01" },
  { key: "si", flag: "si", text: "Slovenia", value: "si", postalCode: "4000" },
  { key: "sb", flag: "sb", text: "Solomon Islands", value: "sb", postalCode: "00000" },
  { key: "so", flag: "so", text: "Somalia", value: "so", postalCode: "JH 09010" },
  { key: "za", flag: "za", text: "South Africa", value: "za", postalCode: "0083" },
  { key: "kr", flag: "kr", text: "South Korea", value: "kr", postalCode: "03051" },
  { key: "es", flag: "es", text: "Spain", value: "es", postalCode: "28039" },
  { key: "lk", flag: "lk", text: "Sri Lanka", value: "lk", postalCode: "20000" },
  { key: "sd", flag: "sd", text: "Sudan", value: "sd", postalCode: "11042" },
  { key: "sr", flag: "sr", text: "Suriname", value: "sr", postalCode: "00000" },
  { key: "sz", flag: "sz", text: "Swaziland", value: "sz", postalCode: "H100" },
  { key: "se", flag: "se", text: "Sweden", value: "se", postalCode: "11455" },
  { key: "ch", flag: "ch", text: "Switzerland", value: "ch", postalCode: "2544" },
  { key: "sy", flag: "sy", text: "Syria", value: "sy", postalCode: "00000" },
  { key: "tw", flag: "tw", text: "Taiwan", value: "tw", postalCode: "104" },
  { key: "tj", flag: "tj", text: "Tajikistan", value: "tj", postalCode: "735450" },
  { key: "tz", flag: "tz", text: "Tanzania", value: "tz", postalCode: "6090" },
  { key: "th", flag: "th", text: "Thailand", value: "th", postalCode: "10150" },
  { key: "tl", flag: "tl", text: "Timorleste", value: "tl", postalCode: "00000" },
  { key: "tg", flag: "tg", text: "Togo", value: "tg", postalCode: "00000" },
  { key: "tk", flag: "tk", text: "Tokelau", value: "tk", postalCode: "00000" },
  { key: "to", flag: "to", text: "Tonga", value: "to", postalCode: "00000" },
  { key: "tt", flag: "tt", text: "Trinidad", value: "tt", postalCode: "00000" },
  { key: "tn", flag: "tn", text: "Tunisia", value: "tn", postalCode: "1002" },
  { key: "tr", flag: "tr", text: "Turkey", value: "tr", postalCode: "01960" },
  { key: "tm", flag: "tm", text: "Turkmenistan", value: "tm", postalCode: "744000" },
  { key: "tv", flag: "tv", text: "Tuvalu", value: "tv", postalCode: "00000" },
  {
    key: "ae",
    flag: "ae",
    text: "UAE",
    value: "ae",
    alias: "United Arab Emirates",
    postalCode: "00000",
  },
  { key: "ug", flag: "ug", text: "Uganda", value: "ug", postalCode: "00000" },
  { key: "ua", flag: "ua", text: "Ukraine", value: "ua", postalCode: "15432" },
  { key: "uk", flag: "uk", text: "United Kingdom", value: "uk", alias: "uk", postalCode: "SW1A 1AA" },
  {
    key: "us",
    flag: "us",
    text: "USA",
    value: "us",
    alias: "America",
    postalCode: "95014",
  },
  { key: "uy", flag: "uy", text: "Uruguay", value: "uy", postalCode: "11600" },
  { key: "um", flag: "um", text: "US Minor Islands", value: "um", postalCode: "96898" },
  { key: "vi", flag: "vi", text: "US Virgin Islands", value: "vi", postalCode: "00802-1222" },
  { key: "uz", flag: "uz", text: "Uzbekistan", value: "uz", postalCode: "702100" },
  { key: "vu", flag: "vu", text: "Vanuatu", value: "vu", postalCode: "00000" },
  { key: "va", flag: "va", text: "Vatican City", value: "va", postalCode: "00120" },
  { key: "ve", flag: "ve", text: "Venezuela", value: "ve", postalCode: "1010" },
  { key: "vn", flag: "vn", text: "Vietnam", value: "vn", postalCode: "70010" },
  { key: "gb wls", flag: "gb wls", text: "Wales", value: "gb wls", postalCode: "CF10 1EP" },
  { key: "wf", flag: "wf", text: "Wallis and Futuna", value: "wf", postalCode: "98600" },
  { key: "eh", flag: "eh", text: "Western Sahara", value: "eh", postalCode: "70000" },
  { key: "ye", flag: "ye", text: "Yemen", value: "ye", postalCode: "00000" },
  { key: "zm", flag: "zm", text: "Zambia", value: "zm", postalCode: "50100" },
  { key: "zw", flag: "zw", text: "Zimbabwe", value: "zw", postalCode: "00000" },
  { key: "bq", flag: "bq", text: "Bonaire", value: "bq", postalCode: "00000" },
]

export const usStateOptions = [
  { key: "AL", value: "AL", text: "Alabama" },
  { key: "AK", value: "AK", text: "Alaska" },
  { key: "AZ", value: "AZ", text: "Arizona" },
  { key: "AR", value: "AR", text: "Arkansas" },
  { key: "CA", value: "CA", text: "California" },
  { key: "CO", value: "CO", text: "Colorado" },
  { key: "CT", value: "CT", text: "Connecticut" },
  { key: "DE", value: "DE", text: "Delaware" },
  { key: "FL", value: "FL", text: "Florida" },
  { key: "GA", value: "GA", text: "Georgia" },
  { key: "HI", value: "HI", text: "Hawaii" },
  { key: "ID", value: "ID", text: "Idaho" },
  { key: "IL", value: "IL", text: "Illinois" },
  { key: "IN", value: "IN", text: "Indiana" },
  { key: "IA", value: "IA", text: "Iowa" },
  { key: "KS", value: "KS", text: "Kansas" },
  { key: "KY", value: "KY", text: "Kentucky" },
  { key: "LA", value: "LA", text: "Louisiana" },
  { key: "ME", value: "ME", text: "Maine" },
  { key: "MD", value: "MD", text: "Maryland" },
  { key: "MA", value: "MA", text: "Massachusetts" },
  { key: "MI", value: "MI", text: "Michigan" },
  { key: "MN", value: "MN", text: "Minnesota" },
  { key: "MS", value: "MS", text: "Mississippi" },
  { key: "MO", value: "MO", text: "Missouri" },
  { key: "MT", value: "MT", text: "Montana" },
  { key: "NE", value: "NE", text: "Nebraska" },
  { key: "NV", value: "NV", text: "Nevada" },
  { key: "NH", value: "NH", text: "New Hampshire" },
  { key: "NJ", value: "NJ", text: "New Jersey" },
  { key: "NM", value: "NM", text: "New Mexico" },
  { key: "NY", value: "NY", text: "New York" },
  { key: "NC", value: "NC", text: "North Carolina" },
  { key: "ND", value: "ND", text: "North Dakota" },
  { key: "OH", value: "OH", text: "Ohio" },
  { key: "OK", value: "OK", text: "Oklahoma" },
  { key: "OR", value: "OR", text: "Oregon" },
  { key: "PA", value: "PA", text: "Pennsylvania" },
  { key: "RI", value: "RI", text: "Rhode Island" },
  { key: "SC", value: "SC", text: "South Carolina" },
  { key: "SD", value: "SD", text: "South Dakota" },
  { key: "TN", value: "TN", text: "Tennessee" },
  { key: "TX", value: "TX", text: "Texas" },
  { key: "UT", value: "UT", text: "Utah" },
  { key: "VT", value: "VT", text: "Vermont" },
  { key: "VA", value: "VA", text: "Virginia" },
  { key: "WA", value: "WA", text: "Washington" },
  { key: "WV", value: "WV", text: "West Virginia" },
  { key: "WI", value: "WI", text: "Wisconsin" },
  { key: "WY", value: "WY", text: "Wyoming" }
];